import { render, staticRenderFns } from "./MPindex.vue?vue&type=template&id=3c075914&scoped=true"
import script from "./MPindex.vue?vue&type=script&lang=js"
export * from "./MPindex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c075914",
  null
  
)

export default component.exports